// app/javascript/controllers/inline_message_controller.js
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["display", "form", "textarea"]
  static values = { url: String }

  connect (){
    console.log("connected to inline_message_controller");
  }

  edit() {
    this.displayTarget.style.display = "none"
    this.formTarget.style.display = "block"
    this.textareaTarget.focus()
  }

  cancel() {
    this.formTarget.style.display = "none"
    this.displayTarget.style.display = "block"
  }

  retry(){
    this.save();
  }

  save() {
    const formData = new FormData()
    formData.append( "user_message", this.textareaTarget.value)
    formData.append( "process_template_id", this.element.dataset.processTemplateIdValue)
    formData.append( "board_id", "")
    fetch(this.url(), {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Accept": "text/javascript"
      },
      body: formData
    }).then(response => response.text())
    .then(js => {
      eval(js)
    })
  } 

  delete() {
    if (!confirm("Delete this message?")) return

    fetch(this.url(), {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "text/html"
      },
      body: new URLSearchParams({
        "user_message": "",
        "draft_markdown": "",
        "reload":true
      })
    }).then((response) => {
       window.location.reload()
    })
  }


  url() {
    return this.element.dataset.inlineMessageUrlValue
  }

  accountId() {
    return document.body.dataset.accountId
  }
}
